// Utilities
import { mapState } from 'vuex';
import { themeColors, themesMixin } from '../../utils/themes';
import ApiService from '../../services/apiService';
export default {
  name: 'CoreFilter',
  mixins: [themesMixin],
  props: {
    userT: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data() {
    var _this$userT$propertie;
    return {
      colors: themeColors,
      mapStyles: [{
        text: 'niotix',
        value: '1'
      }, {
        text: 'Satellite',
        value: '2'
      }, {
        text: 'Streets',
        value: '3'
      }, {
        text: 'Combo',
        value: '4'
      }],
      localUser: {
        ...this.userT,
        properties: {
          ...(this.userT.properties || {}),
          userDefaults: {
            ...(((_this$userT$propertie = this.userT.properties) === null || _this$userT$propertie === void 0 ? void 0 : _this$userT$propertie.userDefaults) || {
              color: 'niotix',
              language: 'de',
              mapLayout: '',
              uiTheme: false,
              drawer: true,
              miniVariant: false,
              map3DBuild: false,
              pagination: 10
            })
          }
        }
      }
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'drawer', 'UiTheme', 'map3DBuild', 'language', 'themes', 'miniVariant', 'color', 'colorHexLight', 'colorHexDark']),
    lang() {
      return this.$store.state.app.language;
    },
    hasCustomColor() {
      return this.UiTheme ? this.colorHexDark : this.colorHexLight;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  watch: {
    'localUser.properties.userDefaults': {
      deep: true,
      handler() {
        this.save();
      }
    }
  },
  mounted() {
    var _this$$store, _this$userT$propertie2;
    const tenantID = (_this$$store = this.$store) === null || _this$$store === void 0 || (_this$$store = _this$$store.state) === null || _this$$store === void 0 || (_this$$store = _this$$store.authentication) === null || _this$$store === void 0 ? void 0 : _this$$store.tenantId;
    if (!((_this$userT$propertie2 = this.userT.properties) !== null && _this$userT$propertie2 !== void 0 && _this$userT$propertie2.userDefaults)) {
      ApiService.tenantGetById(tenantID, ['no-descendents']).then(tenant => {
        this.localUser.properties.userDefaults.color = tenant.data.theme.lightHighlightCustomer ? 'customerColor' : tenant.data.theme.lightHighlight;
      }).catch(e => {
        console.error(e);
      });
    }
  },
  methods: {
    resetDefaults() {
      var _this$$store2;
      const tenantID = (_this$$store2 = this.$store) === null || _this$$store2 === void 0 || (_this$$store2 = _this$$store2.state) === null || _this$$store2 === void 0 || (_this$$store2 = _this$$store2.authentication) === null || _this$$store2 === void 0 ? void 0 : _this$$store2.tenantId;
      ApiService.tenantGetById(tenantID, ['no-descendents']).then(tenant => {
        this.localUser.properties.userDefaults = {
          color: tenant.data.theme.lightHighlightCustomer ? 'customerColor' : tenant.data.theme.lightHighlight,
          language: 'en',
          mapLayout: '',
          uiTheme: false,
          drawer: true,
          miniVariant: false,
          map3DBuild: false,
          pagination: 10,
          customColor: tenant.data.theme.lightHighlightCustomer || tenant.data.theme.lightHighlight
        };
        localStorage.setItem('thingshiveColorLight', tenant.data.theme.lightHighlightCustomer || tenant.data.theme.lightHighlight);
        localStorage.setItem('thingshiveColorDark', tenant.data.theme.lightHighlightCustomer || tenant.data.theme.darkHighlight);
        this.$store.state.app.UiTheme = this.$store.state.app.themeMode === 'dark';
        this.setUiTheme(tenant.data.theme.lightHighlightCustomer);
      }).catch(e => {
        console.error(e);
      });
    },
    save() {
      ApiService.updateUser(this.localUser).then(user => {
        this.setLang();
        this.setColor(user.data.properties.userDefaults.color);
        this.setMapStyle();
        const userCustomColor = user.data.properties.userDefaults.color === 'customerColor' ? user.data.properties.userDefaults.customColor : '';
        this.setUiTheme(userCustomColor);
        this.$store.state.app.drawer = this.localUser.properties.userDefaults.drawer;
        this.$store.state.app.miniVariant = this.localUser.properties.userDefaults.miniVariant;
        this.$store.state.app.map3DBuild = this.localUser.properties.userDefaults.map3DBuild;
        this.$store.state.app.rowsPerPage = this.localUser.properties.userDefaults.pagination;
        localStorage.setItem('userSelectedItemsPerList', this.localUser.properties.userDefaults.pagination);
        this.$snack(this.$i18n_t('Common.userUpdated'), 'success');
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('Common.userUpdatedFail'), 'error');
        }
      });
    },
    setColor(colorKey) {
      const mode = this.$store.state.app.UiTheme ? 'dark' : 'light';
      if (colorKey === 'customerColor') {
        this.$store.state.app.color = mode === 'dark' ? 'customerColorDark' : 'customerColorLight';
      } else {
        this.$store.state.app.color = this.localUser.properties.userDefaults.color;
        localStorage.setItem('thingshiveColorDark', this.$store.state.app.color);
        localStorage.setItem('thingshiveColorLight', this.$store.state.app.color);
      }
    },
    setLang() {
      this.$store.commit('app/language', {
        payload: this.localUser.properties.userDefaults.language,
        context: this
      });
    },
    setMapStyle() {
      localStorage.setItem('mapStyle', this.localUser.properties.userDefaults.mapLayout);
      this.$store.state.app.mapStyle = this.localUser.properties.userDefaults.mapLayout;
    },
    setImage(image) {
      this.$store.state.app.image = image;
      localStorage.setItem('thingshiveImage', this.$store.state.app.image);
    },
    setUiTheme(customColor) {
      const mode = this.localUser.properties.userDefaults.uiTheme ? 'dark' : 'light';
      if (customColor) {
        this.$store.state.app.color = mode === 'dark' ? 'customerColorDark' : 'customerColorLight';
        this.$store.state.app.mode = mode;
        this.$store.state.app.UiTheme = mode === 'dark';
        this.$store.state.app.colorHexLight = customColor;
        this.$store.state.app.colorHexDark = customColor;
        this.$vuetify.theme.themes.light.primary = customColor;
        this.$vuetify.theme.themes.dark.primary = customColor;
        localStorage.setItem('thingshiveColorLight', customColor);
        localStorage.setItem('thingshiveColorDark', customColor);
        localStorage.setItem('thingshiveTheme', mode);
        this.$vuetify.theme.dark = mode === 'dark';
      } else {
        const userHighlight = mode === 'dark' ? localStorage.getItem('thingshiveColorDark') : localStorage.getItem('thingshiveColorLight');
        localStorage.setItem('thingshiveTheme', mode);
        this.$store.state.app.color = userHighlight || this.themes[mode].highlight;
        this.$store.state.app.mode = mode;
        this.$store.state.app.UiTheme = mode === 'dark';
        this.$vuetify.theme.themes.light.primary = localStorage.getItem('thingshiveColorLight') || this.themes.light.highlight;
        this.$vuetify.theme.themes.dark.primary = localStorage.getItem('thingshiveColorDark') || this.themes.dark.highlight;
        this.$vuetify.theme.dark = this.localUser.properties.userDefaults.uiTheme;
      }
    },
    setMap3DBuild() {
      localStorage.setItem('thingshiveMap3DBuild', this.$store.state.app.map3DBuild ? '3D' : '2D');
    },
    setMiniVariant() {
      localStorage.setItem('miniVariant', this.$store.state.app.miniVariant);
    },
    setLoader(a, b = false) {
      this.$store.state.app.load = a;
      this.$store.state.app.loading = b;
    },
    updateUserDefaults(key, value) {
      this.$set(this.localUser.properties.userDefaults, key, value);
    }
  }
};